import cx from 'classnames';
import React from 'react';

import * as styles from './Grid.module.css';

const Grid = ({
	children,
	type = 'default',
	as: Component = 'div',
	className = '',
	equalHeight,
	gap = 'default',
}: {
	children: any;
	type?:
	| 'default'
	| 'fixed'
	| 'stretch'
	| 'static'
	| 'rightheavy'
	| 'sandwich'
	| 'featured'
	| 'square'
	| 'center';
	as?: React.ElementType;
	className?: string;
	equalHeight?: boolean;
	gap?: 'default' | 'large';
}) => {
	return children ? (
		<Component
			className={cx(styles.grid, className, {
				[styles[`${type}Type`]]: type,
				[styles[`${gap}Gap`]]: gap,
				[styles.equalHeight]: equalHeight,
			})}
		>
			{children}
		</Component>
	) : null;
};

export default Grid;
